/* global $ */

const PAGINATION_CLASS = '.js-list-view-pagination';

const Pagination = {
  /**
   * Create pagination for the list view component
   * @param {HTMLElement} listViewNode
   * @return {void}
   */
  initialize(listViewNode, cb) {
    this.cb = cb;
    this.$pagination = $(listViewNode).find(PAGINATION_CLASS);
    this.createListeners();
  },

  createListeners() {
    this.$pagination.on('click', 'a', (e) => {
      e.preventDefault();

      const $el = $(e.currentTarget);
      const rel = $el.attr('rel');

      if (rel === 'prev') {
        return this.cb('decrement');
      } else if (rel === 'next') {
        return this.cb('increment');
      }

      const pageNum = parseInt($el.text(), 10);
      return this.cb('set', pageNum);
    });
  },
};

export default Pagination;
